import { authBinaryFetch, authFetch, convertToJson, createForm } from "utils";

export const getAll = () =>
  authFetch(`${apiUrl}${version}/companies`, {
    method: "GET",
  });

export const get = () =>
  authFetch(`${apiUrl}${version}/company`, {
    method: "GET",
  });

export const save = (company) =>
  authBinaryFetch(`${apiUrl}${version}/companies/${company.company.id}`, {
    method: "PUT",
    body: createForm(company),
  }).then((res) => convertToJson(res));

export const create = (company, plan) =>
  authFetch(`${apiUrl}${version}/companies?plan=${plan}`, {
    method: "POST",
    json: company,
  });
